export const isLowerThan = (n) => (value) => {
  if (value && value >= n) {
    return `Amount entered should be lower than ${n}`;
  }
  return undefined;
};

export default isLowerThan;
